import { parse, type Font } from 'opentype.js';

const toBytes = (encoded: string) =>
  Uint8Array.from(atob(encoded), (character) => character.charCodeAt(0));

const parseSignatureFont = async (): Promise<Font> => {
  const { default: encoded } = await import('./fonts/parisienne');

  return parse(toBytes(encoded).buffer);
};

const cache: { font: Promise<Font> | null } = { font: null };

export const loadSignatureFont = (): Promise<Font> => {
  const loading = cache.font ?? parseSignatureFont();

  cache.font = loading;

  return loading;
};
